import Vue from 'vue';
import Axios from 'axios';
import i18n from '../../i18n';
import { API_HOST } from '../../config/app-const';
import { getUrlParams } from '../../helpers/pagination';
import router from '@/router';

const influencerGroupsApi = (groupId = '') => {
  return `${API_HOST}/influencer_group/${groupId}`;
}
const influencersApi = (influencerId = '') => {
  return `${API_HOST}/influencer_group/influencer/${influencerId}`;
}
const influencerGroupInfluencersApi = (groupId = '') => {
  return `${API_HOST}/influencer_group/detail/${groupId}`;
}
const influencersByGroupIdApi = (groupId = '') => {
  return `${API_HOST}/influencer_group/influencer/group/${groupId}`;
}
const influencersProviderApi = () => {
  return `${API_HOST}/influencer_group/provider/bulk`;
}
const influencerInGroupApi = (groupId, influencerProviderId = '') => {
  return `${API_HOST}/influencer_group/${groupId}/influencer/${influencerProviderId}`;
}
const influencerGroupProjectsApi = (groupId) => {
  return `${API_HOST}/influencer_group/${groupId}/projects`;
}
const influencerGroupByProjectApi = (projectId) => {
  return `${API_HOST}/influencer_group/by-project/${projectId}`;
}
const influencerGroupGeneralProjectsApi = (groupId) => {
  return `${API_HOST}/outlet_groups/projects/search_projects_to_add_to_outlet_group`;
}
// TODO: for future use
const influencerGroupInfluencerImportApi = (groupId = '') => {
  return `${API_HOST}/influencer_group/influencer/import`;
}

const pagination = {
  perPage: 10,
  currentPage: 1
}

const filters = {
  sort: 'asc',
  order: 'name',
  search: null,
  provider: null
}

const state = {
  influencerGroups: {
    isBusy: false,
    isInitiated: false,
    deletedQuery: null,
    data: [],
    pagination: {...pagination},
    filters: {...filters},
    abortController: null
  },
  currentGroup: {
    data: null,
    isBusy: false
  },
  influencers: {
    isBusy: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters, order: 'first_name'},
    error: null
  },
  groupInfluencers: {
    isBusy: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters, order: 'first_name'},
    error: null
  },
  groupProjects: {
    isBusy: false,
    data: {
      included: [],
      excluded: [],
      tiers: [],
      restricted: []
    },
    error: null
  },
  projectGroups: {
    isBusy: false,
    data: {
      included: [],
      excluded: [],
      tiers: [],
      restricted: []
    },
    error: null
  },
  generalProjects: {
    isBusy: false,
    data: [],
    error: null
  },
  projectInfluencerGroups: {
    isLoading: false,
    error: null
  }
}

const mutations = {
  SET_BUSY(state, payload) {
    state.influencerGroups.isBusy = payload
  },
  SET_INITIATE_STATE(state, payload) {
    state.influencerGroups.isInitiated = payload
  },
  SET_QUERY(state, query) {
    state.influencerGroups.filters.query = query
  },
  SET_SOCIAL_CHANNEL(state, channel) {
    state.influencerGroups.filters.provider = channel
  },
  SET_PROJECTID(state, project_id) {
    state.influencerGroups.filters.project_id = project_id
  },
  SET_INFLUENCER_GROUPS(state, { resourceData, pagination: responsePagination, filters: responseFilters, reset = false}) {
    if(reset) {
      state.influencerGroups.isInitiated = false
      state.influencerGroups.data = []
      state.influencerGroups.pagination = {...pagination}
    }
    state.influencerGroups.data = resourceData;
    state.influencerGroups.pagination = { ...state.influencerGroups.pagination, ...responsePagination }
    state.influencerGroups.filters = { ...state.influencerGroups.filters, ...responseFilters }
    state.influencerGroups.isInitiated = true
  },
  SET_GROUPS_ABORT_CONTROLLER(state, controller) {
    state.influencerGroups.abortController = controller;
  },
  CLEAR_GROUPS_ABORT_CONTROLLER(state) {
    state.influencerGroups.abortController = null;
  },
  RESET_PAGINATION(state) {
    state.influencerGroups.pagination = { ...pagination };
  },
  RESET_FILTERS(state) {
    state.influencerGroups.filters = { ...filters };
  },
  SET_GROUP(state, group) {
    const index = state.influencerGroups.data.findIndex(g => g.id === group.id);
    if (index > -1) {
      state.influencerGroups.data.splice(index, 1, { ...state.influencerGroups.data?.[index], ...group});
    } else {
      state.influencerGroups.data.unshift(group);
    }
  },
  REMOVE_GROUP(state, groupId) {
    const index = state.influencerGroups.data.findIndex(g => g.id === groupId);
    if (index > -1) {
      state.influencerGroups.data.splice(index, 1);
    }
  },
  UPDATE_GROUP_INFLUENCERS(state, { groupId, influencers }) {
    const group = state.influencerGroups.data.find(g => g.id === groupId);
    if (group) {
      group.influencers = influencers;
    }
  },
  ADD_INFLUENCER(state, { payload }) {
    state.influencers.data.unshift(payload);
  },
  UPDATE_INFLUENCER(state, { payload }) {
    const influencerIndex = state.influencers.data.findIndex(i => i.id === payload?.id);
    if (influencerIndex > -1) {
      state.influencers.data.splice(influencerIndex, 1, { ...state.influencers.data?.[influencerIndex], ...payload});
    }
  },
  REMOVE_INFLUENCER(state, influencerId) {
    const influencerIndex = state.influencers.data.findIndex(i => i.id === influencerId);
    if (influencerIndex > -1) {
      state.influencers.data.splice(influencerIndex, 1);
    }
  },
  SET_INFLUENCER_PROVIDERS(state, {influencerId, providers}) {
    const influencerIndex = state.influencers.data.findIndex(i => i.id === influencerId);
    if (influencerIndex > -1) {
      state.influencers.data.splice(influencerIndex, 1, { ...state.influencers.data[influencerIndex], providers: providers });
    }
  },
  SET_CURRENT_GROUP(state, group) {
    state.currentGroup.data = {...group};
  },
  SET_CURRENT_GROUP_LOADING(state, loading) {
    state.currentGroup.isBusy = loading;
  },
  SET_INFLUENCERS_BUSY(state, payload) {
    state.influencers.isBusy = payload;
  },
  SET_INFLUENCERS_SUCCESS(state, { resourceData, pagination: responsePagination, filters: responseFilters, reset = false }) {
    if (reset) {
      state.influencers.data = [];
      state.influencers.pagination = { ...pagination };
      state.influencers.filters = { ...filters };
    }
    state.influencers.data = resourceData || [];
    state.influencers.pagination = { ...state.influencers.pagination, ...responsePagination };
    state.influencers.filters = { ...state.influencers.filters, ...responseFilters };
    state.influencers.error = null;
  },
  SET_INFLUENCERS_ERROR(state, payload) {
    state.influencers.error = payload;
  },
  ADD_INFLUENCER_TO_GROUP(state, { groupId, influencer }) {
    if (state.currentGroup?.data?.id) {
      const isInfluencersExists = state.currentGroup?.data?.influencers?.find(gf => gf?.people_id === influencer?.id);
      if(!isInfluencersExists) state.currentGroup.data = { ...state.currentGroup.data, totalinfluencers: (+state.currentGroup.data.totalinfluencers || 0) + 1 };
    }
    const group = state.influencerGroups?.data.find(g => g.id === groupId);
    if (group) {
      const isInfluencersExists = group.influencers?.find(gf => gf?.people_id === influencer?.id);
      if(!isInfluencersExists) {
        state.influencerGroups.data = state.influencerGroups?.data?.map(g => g?.id === group?.id && { ...g, totalinfluencers: (+group.totalinfluencers || 0) + 1 } || g);
      }
    }
  },
  REMOVE_INFLUENCER_FROM_GROUP(state, { groupId, influencerId, influencerProviderId }) {
    const group = state.influencerGroups?.data.find(g => g.id === groupId);
    if (group && +group?.totalinfluencers > 0) {
      const isInfluencersExists = group?.influencers?.find(gf => gf?.people_id === influencerId);
      if(!isInfluencersExists || (isInfluencersExists && isInfluencersExists?.providers?.length === 1)) state.influencerGroups?.data?.map(g => g?.id === group?.id && { ...g, totalinfluencers: +group.totalinfluencers-1 } || g);
    }
    if (+state.currentGroup?.data?.totalinfluencers > 0) {
      const isInfluencersExists = state.currentGroup?.data?.influencers?.find(gf => gf?.people_id === influencerId);
      if(!isInfluencersExists || (isInfluencersExists && isInfluencersExists?.providers?.length === 1)) {
        state.currentGroup.data = {...state.currentGroup.data, totalinfluencers: +state.currentGroup.data.totalinfluencers-1 || 0, influencers: state.currentGroup.data?.influencers?.filter(f => f?.people_id !== influencerId)};
      }
    }
    
    // Remove from influencers list if viewing group
    if (state.groupInfluencers.data?.length) {
      const isInfluencersExists = state.groupInfluencers.data?.find(gf => gf?.id === influencerId);
      if(!isInfluencersExists || (isInfluencersExists && isInfluencersExists?.providers?.length === 1)) state.groupInfluencers.data = state.groupInfluencers.data?.filter(i => i.id !== influencerId);
    }
  },
  SET_GROUP_INFLUENCERS_BUSY(state, payload) {
    state.groupInfluencers.isBusy = payload;
  },

  SET_GROUP_INFLUENCERS(state, { resourceData, pagination, filters, reset = false }) {
    if (reset) {
      state.groupInfluencers.data = [];
      state.groupInfluencers.pagination = { ...pagination };
      state.groupInfluencers.filters = { ...filters };
    }
    state.groupInfluencers.data = resourceData || [];
    state.groupInfluencers.pagination = { ...state.groupInfluencers.pagination, ...pagination };
    state.groupInfluencers.filters = { ...state.groupInfluencers.filters, ...filters };
    state.groupInfluencers.error = null;
  },

  SET_GROUP_INFLUENCERS_ERROR(state, error) {
    state.groupInfluencers.error = error;
  },

  SET_GROUP_PROJECTS_BUSY(state, payload) {
    state.groupProjects.isBusy = payload;
  },
  SET_GROUP_PROJECTS(state, data) {
    state.groupProjects.data = {
      included: data.included || [],
      excluded: data.excluded || [],
      tiers: data.tiers || [],
      restricted: data.restricted || []
    };
    state.groupProjects.error = null;
  },
  SET_GROUP_PROJECTS_ERROR(state, error) {
    state.groupProjects.error = error;
  },

  SET_GROUPS_BY_PROJECT_ID_BUSY(state, payload) {
    state.projectGroups.isBusy = payload;
  },
  SET_GROUPS_BY_PROJECT_ID(state, data) {
    state.projectGroups.data = {
      included: data.included || [],
      excluded: data.excluded || [],
      tiers: data.tiers || [],
      restricted: data.restricted || []
    };
    state.projectGroups.error = null;
  },
  SET_GROUPS_BY_PROJECT_ID_ERROR(state, error) {
    state.projectGroups.error = error;
  },

  SET_GENERAL_PROJECTS_BUSY(state, payload) {
    state.generalProjects.isBusy = payload;
  },

  SET_GENERAL_PROJECTS(state, data) {
    state.generalProjects.data = data;
    state.generalProjects.error = null;
  },

  SET_GENERAL_PROJECTS_ERROR(state, error) {
    state.generalProjects.error = error;
  },
  SET_PROJECT_INFLUENCER_GROUPS_LOADING(state, payload) {
    state.projectInfluencerGroups.isLoading = payload;
  },
  
  SET_PROJECT_INFLUENCER_GROUPS_ERROR(state, error) {
    state.projectInfluencerGroups.error = error;
  }
}

const actions = {
  getInfluencerGroups({commit, state, rootState}, {projectId, pagination: _pagination = {}, filters: _filters = {}, channel = ''}) {
    // Cancel the previous request if there is one
    if (state.influencerGroups?.abortController) {
      state.influencerGroups.abortController?.cancel('cancelled');
      commit("CLEAR_GROUPS_ABORT_CONTROLLER");
    }

    // Create a new AbortController/cancelToken instance for the current request
    const CancelToken = Axios.CancelToken;
    const controller = CancelToken.source();
    commit("SET_GROUPS_ABORT_CONTROLLER", controller);
    
    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` },
      cancelToken: controller.token
    };

    const requestFilters = { ...rootState.influencerGroups.influencerGroups.filters, ..._filters };
    const requestPagination = { ...rootState.influencerGroups.influencerGroups.pagination, ..._pagination };
    let url = influencerGroupsApi();
    const query = getUrlParams({ ...requestPagination, ...requestFilters });
    if (query) url += `?${query}`;
    
    return new Promise((resolve, reject) => {
      if(requestPagination?.currentPage && requestPagination?.currentPage >= requestPagination?.totalPages) reject()
        commit('SET_BUSY', true)
      Axios.get(url, config)
        .then(({data}) => {
          const {status, data: { data: resourceData, pagination }} = data
          commit("SET_INFLUENCER_GROUPS", { resourceData, pagination, reset: pagination.currentPage === 1})
          resolve(data)
        })
        .catch((e) => reject(e))
        .finally(() => {
          commit('SET_BUSY', false)
          commit('SET_INITIATE_STATE', true)
        })
    })
  },

  async getInfluencersByGroupId({ commit, rootState }, { projectId, groupId, filters: _filters = {}, pagination: _pagination = {} }) {
    commit('SET_GROUP_INFLUENCERS_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    const requestFilters = { ...rootState.influencerGroups.influencers.filters, ..._filters };
    const requestPagination = { ...rootState.influencerGroups.influencers.pagination, ..._pagination };
    let url = influencersByGroupIdApi(groupId);
    const query = getUrlParams({ ...requestPagination, ...requestFilters });
    if (query) url += `?${query}`;

    try {
      const { data } = await Axios.get(url, config);
      const { status, data: { data: resourceData, pagination } } = data;
      commit('SET_GROUP_INFLUENCERS',  { resourceData, pagination: { ...requestPagination, ...pagination }, filters: requestFilters, reset: requestPagination.currentPage === 1})
      commit('SET_GROUP_INFLUENCERS_BUSY', false);
      return resourceData;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
      commit('SET_GROUP_INFLUENCERS_ERROR', error);
      throw error;
    } finally {
      commit('SET_GROUP_INFLUENCERS_BUSY', false);
    }
  },

  async getGroupWithInfluencers({ commit, rootState }, { groupId, projectId }) {
    commit('SET_CURRENT_GROUP_LOADING', true)
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    const url = influencerGroupInfluencersApi(groupId);

    try {
      const { data: { data } } = await Axios.get(url, config)
      commit('SET_CURRENT_GROUP', data)
      return data
    } catch (error) {
      throw error
    } finally {
      commit('SET_CURRENT_GROUP_LOADING', false)
    }
  },

  async getInfluencers({ commit, rootState }, { filters: _filters = {}, pagination: _pagination = {} }) {
    commit('SET_INFLUENCERS_BUSY', true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    const requestFilters = { ...rootState.influencerGroups.influencers.filters, ..._filters };
    const requestPagination = { ...rootState.influencerGroups.influencers.pagination, ..._pagination };
    let url = influencersApi();
    const query = getUrlParams({ ...requestPagination, ...requestFilters });
    if (query) url += `?${query}`;

    try {
      const { data } = await Axios.get(url, config);
      const { status, data: { data: resourceData, pagination } } = data;

      commit('SET_INFLUENCERS_SUCCESS', { resourceData, pagination: {...requestPagination, ...pagination}, filters: requestFilters, reset: requestPagination.currentPage === 1});
      commit('SET_INFLUENCERS_BUSY', false);
      return resourceData;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
      commit('SET_INFLUENCERS_ERROR', error);
      throw error;
    } finally {
      commit('SET_INFLUENCERS_BUSY', false);
    }
  },

  async getInfluencer({ commit, rootState }, { projectId, groupId, influencerId }) {
    commit('SET_CURRENT_GROUP_LOADING', true)
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    const url = influencersApi(influencerId);
    try {
      const { data: { data } } = await Axios.get(url, config)
      // commit('SET_CURRENT_GROUP', data)
      return data;
    }
    catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
      throw error
    }
    finally {
      commit('SET_CURRENT_GROUP_LOADING', false)
    }
  },

  async saveInfluencerGroup({ commit, rootState }, { projectId, group }) {
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    let url = influencerGroupsApi(group.id);
    
    try {
      const { data: { data } } = await Axios[group.id ? 'put' : 'post'](url, { ...group }, config)
      const _group = { ...group, totalinfluencers: !group.id ? 0 : group?.totalinfluencers, id: data?.[0]?.id || group.id };
      commit('SET_GROUP', _group);
      commit('SET_CURRENT_GROUP', _group);
      Vue.notify({
        group: 'store_notifications',
        type: 'success',
        text: i18n.t(`influencers.messages.${group.id ? 'update' : 'create'}.success`)
      });
      if(!group.id) router.push({ name: 'influencer-groups-detail', params: { id: _group?.id } });
      return _group;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('influencers.messages.request.error')
      });
      throw error
    }
  },

  async deleteInfluencerGroup({ commit, rootState }, { projectId, groupId }) {
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    const url = influencerGroupsApi(groupId);

    try {
      await Axios.delete(url, config)
      commit('REMOVE_GROUP', groupId)
      Vue.notify({
        group: 'store_notifications',
        type: 'success',
        text: i18n.t('influencers.messages.delete.success')
      });
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('influencers.messages.request.error')
      });
      throw error
    }
  },

  async addInfluencer({ commit, state, rootState }, { groupId, projectId, payload }) {
    commit('SET_INFLUENCERS_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    const url = influencersApi();

    try {
      const { data: { data } } = await Axios.post(url, { ...payload }, config)
      const _data = data?.[0] || payload;
      commit('ADD_INFLUENCER', { payload: _data });
      Vue.notify({
        group: 'store_notifications',
        type: 'success',
        text: i18n.t('influencers.messages.create.success')
      });
      return _data;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('influencers.messages.create.error')
      });
      commit('SET_INFLUENCERS_ERROR', error);
      throw error
    } finally {
      commit('SET_INFLUENCERS_BUSY', false);
    }
  },

  async updateInfluencer({ commit, state, rootState }, { projectId, groupId, payload }) {
    commit('SET_INFLUENCERS_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    const url = influencersApi(payload?.id);

    try {
      const { data: { data } } = await Axios.put(url, { ...payload }, config);
      commit('UPDATE_INFLUENCER', { payload: data?.[0] || payload });
      
      Vue.notify({
        group: 'store_notifications',
        type: 'success',
        text: i18n.t('influencers.messages.update.success')
      });

      return data;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('influencers.messages.update.error')
      });
      commit('SET_INFLUENCERS_ERROR', error);
      throw error;
    } finally {
      commit('SET_INFLUENCERS_BUSY', false);
    }
  },

  async removeInfluencer({ commit, state, rootState }, { groupId, projectId, influencerId }) {
    commit('SET_INFLUENCERS_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    const url = influencersApi(influencerId);

    try {
      await Axios.delete(url, config);
      commit('REMOVE_INFLUENCER', influencerId);
      Vue.notify({
        group: 'store_notifications',
        type: 'success',
        text: i18n.t('influencers.messages.delete.success')
      });
      return influencerId;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('influencers.messages.delete.error')
      });
      commit('SET_INFLUENCERS_ERROR', error);
      throw error
    } finally {
      commit('SET_INFLUENCERS_BUSY', false);
    }
  },

  async restoreInfluencer({ commit, state, rootState }, { influencerId, ...payload }) {
    commit('SET_INFLUENCERS_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    const url = influencersApi(influencerId);

    try {
      const _payload = { id: influencerId, ...payload, active: true };
      const { data: { data } } = await Axios.put(url, _payload, config);
      // Update in list if present
      const restored = (data && data[0]) || _payload;
      commit('UPDATE_INFLUENCER', { payload: restored });
      Vue.notify({
        group: 'store_notifications',
        type: 'success',
        text: i18n.t('influencers.messages.update.success')
      });
      return restored;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('influencers.messages.update.error')
      });
      commit('SET_INFLUENCERS_ERROR', error);
      throw error;
    } finally {
      commit('SET_INFLUENCERS_BUSY', false);
    }
  },

  async saveInfluencerProviders({ commit, rootState }, { projectId, groupId, influencerId, payload }) {
    commit('SET_INFLUENCERS_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    const url = influencersProviderApi();
    try {
      const { data: { data } } = await Axios.post(url, {people_id: influencerId, ...payload}, config);
      commit('SET_INFLUENCER_PROVIDERS', {influencerId, providers: data});
      Vue.notify({
        group: 'store_notifications',
        type: 'success',
        text: i18n.t(`influencers.messages.${influencerId ? 'update' : 'create'}.success`)
      });
      return data;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t(`influencers.messages.${influencerId ? 'update' : 'create'}.error`)
      });
      commit('SET_INFLUENCERS_ERROR', error);
      throw error
    } finally {
      commit('SET_INFLUENCERS_BUSY', false);
    }
  },

    // TODO: for future use
  async importInfluencers({ commit, state, rootState }, { projectId, groupId, file }) {
    const { accessToken } = rootState.user.user.data;
    const formData = new FormData()
    formData.append('file', file)

    const config = { 
      headers: { 
        Authorization: `Token token=${accessToken}`,
        'Content-Type': 'multipart/form-data'
      }
    };

    try {
      commit('SET_INFLUENCERS_BUSY', true);
      const url = influencerGroupInfluencerImportApi(groupId);
      const { data } = await Axios.post(url, formData, config);
      
      if (data?.influencers) {
        commit('SET_INFLUENCERS_SUCCESS', { 
          resourceData: data.influencers,
          pagination: state.influencers.pagination,
          reset: true
        });
      }

      Vue.notify({
        group: 'store_notifications',
        type: 'success',
        text: i18n.t('influencers.messages.import.success')
      });

      return data;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('influencers.messages.import.error')
      });
      throw error;
    } finally {
      commit('SET_INFLUENCERS_BUSY', false);
    }
  },

  async addInfluencerToGroup({ commit, rootState }, { groupId, influencer }) {
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    commit('SET_GROUP_INFLUENCERS_BUSY', true);
    try {
      const url = influencerInGroupApi(groupId);
      const { data: { data } } = await Axios.post(url, influencer, config);
      
      commit('ADD_INFLUENCER_TO_GROUP', { 
        groupId,
        influencer,
        influencerProvider: data
      });

      Vue.notify({
        group: 'store_notifications',
        type: 'success',
        text: i18n.t('influencers.messages.influencer_added')
      });

      return data;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('influencers.messages.error_add')
      });
      throw error;
    } finally {
      commit('SET_GROUP_INFLUENCERS_BUSY', false);
    }
  },

  async removeInfluencerFromGroup({ commit, rootState }, { groupId, influencerProviderId, influencerId }) {
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    
    try {
      const url = influencerInGroupApi(groupId, influencerProviderId);
      await Axios.delete(url, config);
      
      commit('REMOVE_INFLUENCER_FROM_GROUP', { groupId, influencerId, influencerProviderId });
      Vue.notify({
        group: 'store_notifications',
        type: 'success',
        text: i18n.t('influencers.messages.influencer_removed')
      });
      return true;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('influencers.messages.error_remove')
      });
      throw error;
    }
  },

  async getGroupsByProjectId({ commit, rootState }, { projectId }) {
    commit('SET_GROUPS_BY_PROJECT_ID_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    
    try {
      const url = influencerGroupByProjectApi(projectId);
      const { data } = await Axios.get(url, config);
      commit('SET_GROUPS_BY_PROJECT_ID', {included: data});
      return data;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
      commit('SET_GROUPS_BY_PROJECT_ID_ERROR', error);
      throw error;
    } finally {
      commit('SET_GROUPS_BY_PROJECT_ID_BUSY', false);
    }
  },

  async getGroupProjects({ commit, rootState }, { groupId }) {
    commit('SET_GROUP_PROJECTS_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    
    try {
      const url = influencerGroupProjectsApi(groupId);
      const { data: { data } } = await Axios.get(url, config);
      commit('SET_GROUP_PROJECTS', {included: data});
      return data;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
      commit('SET_GROUP_PROJECTS_ERROR', error);
      throw error;
    } finally {
      commit('SET_GROUP_PROJECTS_BUSY', false);
    }
  },

  async updateGroupProjects({ commit, rootState }, { groupId, related_project_ids }) {
    commit('SET_GROUP_PROJECTS_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    
    try {
      const url = influencerGroupProjectsApi(groupId);
      const { data: { data } } = await Axios.put(url, { included_project_ids: related_project_ids }, config);
      
      // commit('SET_GROUP_PROJECTS', {restricted: data});
      Vue.notify({
        group: 'store_notifications',
        type: 'success',
        text: i18n.t('influencers.messages.project.updated')
      });
      
      return data;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('influencers.messages.project.error_update')
      });
      commit('SET_GROUP_PROJECTS_ERROR', error);
      throw error;
    } finally {
      commit('SET_GROUP_PROJECTS_BUSY', false);
    }
  },

  async getGroupGeneralProjects({ commit, rootState }, { groupId, query = '' }) {
    commit('SET_GENERAL_PROJECTS_BUSY', true);
    const { accessToken } = rootState.user.user.data;
    const config = { headers: { Authorization: `Token token=${accessToken}` } };
    
    try {
      const url = `${influencerGroupGeneralProjectsApi()}?q=${encodeURIComponent(query)}&outlet_group_id=${groupId}`;
      const { data: { data } } = await Axios.get(url, config);
      commit('SET_GENERAL_PROJECTS', data);
      return data;
    } catch (error) {
      Vue.notify({
        group: 'store_notifications',
        type: 'error',
        text: i18n.t('messages.request.error')
      });
      commit('SET_GENERAL_PROJECTS_ERROR', error);
      throw error;
    } finally {
      commit('SET_GENERAL_PROJECTS_BUSY', false);
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}